export default __webpack_public_path__ + "static/Card1-7f3877e0074096f4899f55d2c40bec46.png";